<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<nav role="navigation" class="navbar navbar-expand-lg fixed-top" id="top-nav">
  <div class="navbar-brand" id="top-nav-logo">
    <div class="siteTitle text-center">
      <span
        class="mr-4 mt-3"
        style="display: inline-block"
        [hidden]="!isUserLogged || !menuCollapsed"
        (click)="showMenu()"
      >
        <fa-icon [icon]="faBars"></fa-icon>
      </span>
      <img
        [src]="'/assets/img/provisioning_whiteful.png'"
        height="68px"
        title="Medfusion Merchant Provisioning"
        alt="Medfusion Merchant Provisioning Logo"
        class="d-inline-block align-top"
      />
    </div>
  </div>
  <div
    class="nav-item nav-info"
    *ngIf="merchantInfo && hasRoute('\\/merchants\\/\\d')"
  >
    <div class="nav-info-content" data-ng-if="!isMerchantInfoEmpty()">
      <div class="navMerchantStatus">
        <span class="navMerchantId">
          {{ merchantInfo.id }}
        </span>
        <span
          class="label fixBootstrapLabel headerLabel"
          [ngClass]="{
            'label-white':
              merchantInfo.status === 'ACTIVE' ||
              merchantInfo.status === 'TEST',
            'label-danger': merchantInfo.status === 'INACTIVE'
          }"
        >
          {{ merchantInfo.status }}
        </span>
        <span
          *ngIf="
            !(merchantInfo.status === 'ACTIVE') && getMerchantDeactivatedDate()
          "
        >
          &nbsp;(since
          {{ getMerchantDeactivatedDate() | date: "MM/dd/yyyy @ h:mma" }})
        </span>
      </div>

      <div class="navMerchantName mt-1">
        {{ merchantInfo.merchantName }}
      </div>
    </div>
  </div>

  <div class="ml-auto mr-1 text-right" *ngIf="isUserLogged">
    <div>Welcome {{ username }}</div>
    <button class="btn btn-primary mt-1 mb-1" (click)="logOut()">
      Logout
      <span class="oi oi-account-logout"></span>
    </button>
  </div>
</nav>
